<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')" title="登录状态" name="1">
        <div class="verticallyCenter">
          <label class="fs14 mr16">状态</label>
          <el-radio-group v-model="loginStatus">
            <el-radio label="1" class="mr24">登录前</el-radio>
            <el-radio label="2">登录后</el-radio>
          </el-radio-group>
        </div>
        <div class="mt16">
          <div class="verticallyBetween">
<!--            <span class="verticallyCenter">下拉菜单<i class="tips-btn icon-portal-info2"></i></span>-->
            <span class="verticallyCenter">下拉菜单</span>
            <span class="add-menu icon-portal-plus" @click="handleCommand('add')"></span>
          </div>
          <div class="menu-box">
            <draggable
              element="ul"
              v-model="menuLists"
              handle=".mover"
              ghost-class="ghost"
              chosen-class="chosen"
              @start="startDrag"
              @end="endDrag"
              filter=".disabled"
            >
              <li class="menu-item verticallyCenter" v-for="(item, index) in menuLists.slice(0,menuLists.length - 1)" :key="index">
                <i class="mover icondrag icon-portal-drag" :class="dragging ? 'dragging' : ''"></i>
                <span class="text overflowHid1">{{ item.label }}</span>
                <div class="btn-box">
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top" :open-delay="1000"
                    ><span class="icon-portal-edit-1" @click.stop="handleCommand('edit', item, index)"></span
                  ></el-tooltip>
                  <el-tooltip
                    v-if="!item.showSchool"
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="top"
                    :open-delay="1000"
                    ><span class="icon-portal-delete1" @click.stop="handleDel(index)"></span
                  ></el-tooltip>
                </div>
              </li>
              <div v-if="!menuLists" class="null-box">暂无内容</div>
            </draggable>
            <!-- 退出登录不能删除 -->
            <div class="menu-item verticallyCenter">
              <i class="icondrag icon-portal-drag disabled"></i>
              <span class="text overflowHid1">{{ menuLists[menuLists.length - 1].label }}</span>
              <!-- <div class="btn-box">
                <el-tooltip class="item" effect="dark" content="编辑" placement="top" :open-delay="1000"
                  ><span class="icon-portal-edit-1" @click.stop="handleCommand('edit', menuLists[menuLists.length - 1], menuLists.length - 1)"></span
                ></el-tooltip>
              </div> -->
            </div>
          </div>
        </div>
        <div class="mt16">
          <div class="verticallyBetween">
            <el-checkbox v-model="isShowChangeSchool">切换单位设置</el-checkbox>
          </div>
          <div class="menu-box" v-if="isShowChangeSchool">
            <ul>
              <li class="menu-item verticallyCenter" v-for="(item, index) in schoolList" :key="index">
                <span class="text overflowHid1 widthlarge">{{ item.label }}</span>
                <div class="btn-box">
                  <el-tooltip class="item" effect="dark" content="编辑" placement="top" :open-delay="1000"
                    ><span class="icon-portal-edit-1" @click.stop="handleSchoolCommand('edit', item, index)"></span
                  ></el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="top"
                    :open-delay="1000"
                    ><span class="icon-portal-delete1" @click.stop="handleSchoolDel(item,index)"></span
                  ></el-tooltip>
                </div>
              </li>
            </ul>
            <div class="add-select" @click="handleSchoolCommand('add')"><span class="icon-portal-plus"></span>添加选项</div>
          </div>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="menu-set-dialog-wrap padding12" @click.stop="closeSetStatu" v-show="showSetDialog">
      <div class="menu-set-dialog" @click.stop>
        <div class="dialog-title verticallyBetween">
          <span v-if="schoolSet">单位设置</span>
          <span v-else>下拉菜单</span>
          <span class="close el-icon el-icon-close" @click.stop="closeSetStatu"></span>
        </div>
        <div class="dialog-content">
          <el-input v-if="schoolSet" placeholder="请输入名称" v-model="schoolName"></el-input>
          <el-select v-if="schoolSet" v-model="selectSchoolId" @change="handleChangeSchool()" class="school-select mt8">
            <el-option
              v-for="(item, index) in currentSchoolList"
              :key="index"
              :value="item.fid"
              :label="item.schoolname"
              >{{item.schoolname}}
            </el-option>
            <el-pagination
              layout="prev, pager, next"
              :hide-on-single-page="true"
              @current-change="handleCurrentChange"
              :page-size="pageSize"
              :total="totalNum"
            >
            </el-pagination>
          </el-select>
          <el-input v-else v-model="entryList.label" placeholder="请输入菜单名称"></el-input>
          <div class="select-box mt8">
            <el-select v-if="schoolSet && selectSchoolId" v-model="selectRoleIds" multiple :multiple-limit="50" @change="handleRoleSchool()" class="school-select" placeholder="不限角色">
              <el-checkbox class="checked-all" v-model="allChecked" @change="selectAllRoles">全选</el-checkbox>
              <el-checkbox-group v-model="selectRoleIds">
                <el-option
                  v-for="(item, index) in currentRoleIdsList"
                  :key="index"
                  :value="item.roleid"
                  :label="item.roleName"
                  >
                  <el-checkbox style="pointer-events: none;" :label="item.roleid">
                    {{item.roleName}}
                  </el-checkbox>
                </el-option>
              </el-checkbox-group>
              <el-pagination
                layout="prev, pager, next"
                :hide-on-single-page="true"
                @current-change="handleRolesChange"
                :page-size="pageSize"
                :total="roleTotalNum"
              >
              </el-pagination>
            </el-select>
          </div>
          <el-input v-if="!entryList.showSchool || schoolSet" v-model="entryList.value" class="text-inp mt8" type="textarea" :autosize="{ minRows: 2, maxRows: 4}" resize="none" placeholder="请输入http://或https://开头的地址"></el-input>
          <el-checkbox v-if="!entryList.showSchool || schoolSet" v-model="entryList.ifNewOpenLog" class="mt8">新页面打开</el-checkbox>
        </div>
        <div class="dialog-footer">
          <el-button type="default" @click.stop="closeSetStatu">取消</el-button>
          <el-button type="primary" @click="saveMenuClick">保存</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Qs from "qs"
import $ from "jquery"
import draggable from "vuedraggable"
import { handleFindLayoutComponentOptions, getAllColsUidInLayoutComponent } from "utils"
export default {
  components: {
    draggable
  },
  props: {
  },
  data() {
    return {
      activeNames: ["1", "2", "3"], 
      collapseActiveNames: ["1", "2", "3"],
      dragging: false,
      showSetDialog: false,
      entryLabel: "",
      entryLink: "",
      ifNewOpenLog: false,
      colsUid: null,
      selectItem: null,
      entryList: {
        label: "",
        value: "",
        ifNewOpenLog: false,
        id: "",
        fid: "",
      },
      currentSchoolList: null,
      selectSchoolId: "",
      schoolSet: false, //单位设置标签,
      pageNum: 1,
      pageSize: 10,
      totalNum: 0,
      schoolList: [],
      isGetList: true,
      currentRoleIdsList: [],
      selectRoleIds: [],
      schoolName: "",
      rolePageNum: 1,
      roleTotalNum: 0,
      allChecked: false,
      allSchoolList: [], //所有单位 用于查询角色
      allRoleIdsList: [] //当前单位的所有角色
    }
  },
  watch: {
    loginStatus: function(newVal) {
      if (newVal == "1") {
        this.$changeOptionsEV(0, "activeIndex", false, null, {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        }, true)
        // 切换未登录时 屏蔽注册按钮
        const uid = getAllColsUidInLayoutComponent([this.getOptions.rows[0]])[0]
        let beforeLoginLement = handleFindLayoutComponentOptions([this.getOptions.rows[0]], uid)
        beforeLoginLement.forEach((element) => {
          switch (element.loginType) {
            case "registerBtn":
              let registClass = "container_id_" + this.ids.container_id + "-rect_id_" + this.ids.rect_id + "-uid_" + uid + "-elementInLayoutId_" + element.elementInLayoutId
              setTimeout(() => {
                if (document.getElementsByClassName(registClass).length > 0) {
                  document.getElementsByClassName(registClass)[0].style.display = "none"
                }
              }, 200)
              break
          }
        })
      } else if(newVal == "2") {
        this.$changeOptionsEV(1, "activeIndex", false, null, {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        }, true)
      }
    },
    isShowChangeSchool: function(newVal) {
      if (newVal) {
        let item = this.menuLists.find(item=>item.showSchool === true)
        if(!item) {
          const menuItem = {
            showSchool: true,
            label: "切换校区",
            value: "",
            ifNewOpenLog: false
          }
          this.menuLists.splice(this.menuLists.length - 1,0,menuItem)
        }
        if (this.isGetList) {
          this.getSchoolList()
          this.getSelectList()
        }
        this.isGetList = false
      } else {
        let index = this.menuLists.findIndex(item=>item.showSchool === true)
        if (index!= -1) {
          this.menuLists.splice(index,1)
        }
      }
    }
  },
  async mounted() {
    if (this.isShowChangeSchool) {
      await this.getSelectList()
      this.getSchoolList()
      this.isGetList = false
    }
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    getOptions: function () {
      let rect = this.getRectAttribute.call(this, this.ids)
      if (rect && this.ids.elementInAutoLayoutId !== undefined && rect.shape === "cxAutoLayout") {
        return this.getAttrById(this.$store.state[this.request_prefix], this.ids)
      }
      return this.getRectAttribute.call(this, this.ids).options
    },
    loginStatus: {
      get() {
        return this.getOptions.loginStatus || "2"
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "loginStatus", false)
      }
    },
    dragLists() {
      // 最后一个元素不参与拖拽
      let list = this.menuLists
      return list.slice(0,list.length - 1)
    },
    menuLists: {
      get() {
        this.getSelectItem()
        let selectOptions = this.selectItem.selectOptions[0].children
        return selectOptions
      },
      set(newVal) {
        let selectOptions = this.selectItem.selectOptions
        selectOptions[0].children = newVal
        this.$changeOptionsEV(selectOptions, "selectOptions", false, null, {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          uid: this.colsUid,
          elementInLayoutId: this.selectItem.elementInLayoutId,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
          path: this.ids.path
        })
      }
    },
    isShowChangeSchool: {
      get() {
        return this.getOptions.hasOwnProperty("isShowChangeSchool") ? this.getOptions.isShowChangeSchool : false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "isShowChangeSchool", false)
      }
    },
    websiteId() {
      return this.$store.state.states.getDataPageIds.websiteId
    },
  },
  methods: {
    getSelectItem() {
      const layoutRowsArr = this.getOptions.rows[1]
      this.colsUid = getAllColsUidInLayoutComponent([layoutRowsArr])[0] //获取当前row里的所有cols的uid
      this.selectItem = handleFindLayoutComponentOptions([this.getOptions.rows[1]], this.colsUid)[1]
    },
    closeSetStatu() {
      this.showSetDialog = undefined
      this.schoolSet = false
    },
    addMenuClick() {
      this.showSetDialog = true
    },
    startDrag(e) {
      this.dragging = true
    },
    endDrag(e) {
      this.dragging = false
    },
    handleCommand(type, item, index) {
      this.showSetDialog = true
      if (type === 'edit') {
        this.entryList.label = item.label
        this.entryList.value = item.value
        this.entryList.ifNewOpenLog = item.ifNewOpenLog
      } else {
        this.entryList.label = ""
        this.entryList.value = ""
        this.entryList.ifNewOpenLog = false
      }
      item && item.showSchool ? this.entryList.showSchool = item.showSchool : this.entryList.showSchool = false
      this.entryList.type = type
      this.entryList.index = index
    },
    handleDel(index) {
      this.menuLists.splice(index,1)
    },
    saveMenuClick() {
      if (!this.entryList.label) return
      if (!this.entryList.value && (!this.entryList.showSchool || this.schoolSet)) {
        /* 有地址输入框时才进行判断 */
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          type: "warning",
          message: "请输入地址！"
        })
        return
      }
      this.showSetDialog = false
      const menuItem = {
        children: [],
        label: this.entryList.label,
        value: this.entryList.value,
        ifNewOpenLog: this.entryList.ifNewOpenLog,
        id: this.entryList.id,
        fid: this.entryList.fid
      }
      this.entryList.showSchool ? menuItem.showSchool = this.entryList.showSchool : ""
      if (this.schoolSet) {
        this.updateList(menuItem)
      } else {
        // 添加菜单的逻辑
        if (this.entryList.type === "edit") {
          this.menuLists[this.entryList.index] = menuItem
        } else {
          // 添加最后一个 退出登录 不能删除
          this.menuLists.splice(this.menuLists.length - 1,0,menuItem)
        }
      }
      this.schoolSet = false
    },
    updateList(item) {
      let target = item.ifNewOpenLog ? 1 : 0
      let id = item.id ? item.id : ""
      this.entryList.type === "add" ? id = "" : ""
      let fid = item.fid ? item.fid : ""
      let urlValue = encodeURIComponent(item.value)
      let roleIds = this.entryList.roleIds ? JSON.stringify(this.entryList.roleIds) : []
      let url = `v2/website-wfwfid-uri-setting/${this.websiteId}/update?id=${id}&fid=${fid}&uri=${urlValue}&target=${target}&des=${this.schoolName}&roleIds=`
      let params = {
        roleIds: roleIds
      }
      let list = this.schoolList
      this.instance.post(url, JSON.parse(JSON.stringify(params))).then(res=> {
        if (res.data.code === 1) {
          if (res.data.data) {
            // item.id = res.data.data.id
            // if (this.entryList.type === "edit") {
            //   list[this.entryList.index] = item
            // } else {
            //   // 添加到最后一个
            //   list.splice(this.schoolList.length,0,item)
            // }
            // this.schoolList = list
          }
          // 修改后重新获取数据
          this.getSchoolList()
          // this.getSelectList()
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "success",
            message: "保存成功"
          })
        } else {
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            message: "保存失败",
            type: "error"
          })
        }
      })
    },
    getSelectList(type) {
      let pageSize = type === "all" ? this.totalNum : this.pageSize
      let url = `v2/website-wfwfid-uri-setting/${this.websiteId}/admin-list?pageSize=${pageSize}&pageNum=${this.pageNum}`
      return this.instance.get(url).then(res=> {
        if(res.data.code === 1) {
          if (type === "all") {
            this.allSchoolList = res.data.data.datas
          } else {
            this.currentSchoolList = res.data.data.datas
          }
          this.totalNum = res.data.data.total
        }
      })
      // 10测试数据
      // this.currentSchoolList = [{"fid":67395,"des":null,"dxfid":41703,"type":1,"uri":"http://mh.chaoxing.com/aaa","schoolname":"图书馆办公","status":"0","roleIds": [{"roleid":"1","roleName":"角色1"},{"roleid":"2","roleName":"角色2"}]}]
    },
    /* 获取勾选单位的所有角色 */
    getRoleList(type) {
      let pageSize = type === "all" ? this.roleTotalNum : this.pageSize
      let rolePageNum = type === "all" ? 1 : this.rolePageNum
      let url = `v2/website-wfwfid-uri-setting/${this.websiteId}/${this.selectSchoolId}/admin-list-role?p=${rolePageNum}&p2=${pageSize}`
      return this.instance.get(url).then(res=> {
        if(res.data.code === 1) {
          if (type === "all") {
            this.allRoleIdsList = res.data.data.datas
          } else {
            this.currentRoleIdsList = res.data.data.datas
            this.roleTotalNum = res.data.data.total
          }
        }
      })
    },
    getSchoolList() {
      let url = `v2/website-wfwfid-uri-setting/${this.websiteId}/list?admin=true`
      this.instance.get(url).then(async res=> {
        if(res.data.code === 1) {
          let list = res.data.data.datas
          // let list = [
          //   {
          //     "fid": 44798,
          //     "des": "",
          //     "dxfid": 41703,
          //     "id": 7,
          //     "type": 1,
          //     "uri": "https://www.baidu.com/",
          //     "schoolname": "湖北省群众艺术馆",
          //     "status": "0",
          //     "target": 0
          //   },
          // ]
          // 总条数大于10需要获取全部单位 查找当前的页数
          if (this.totalNum > this.pageSize) {
            await this.getSelectList("all")
          }
          this.schoolList = list.map(item=>{            
            let index = this.allSchoolList.findIndex(it => it.fid === item.fid)            
            let pageNum = parseInt(index / this.pageSize) + 1             
            return {
              label: item.des ? item.des : item.schoolname,
              value: item.uri,
              ifNewOpenLog: item.target === 1 ? true : false,
              fid: item.fid,
              id: item.id,
              pageNum: pageNum,
              des: item.des, //修改后的单位名称
              roleIds: item.roleIds
            }
          })
        }
      })
    },
    async handleSchoolCommand(type, item, index) {      
      console.log('item :>>',item);
      this.schoolSet = true
      this.showSetDialog = true
      this.pageSize = 10
      this.rolePageNum = 1
      if (type === 'edit') {
        this.entryList.label = item.label
        this.entryList.value = item.value
        this.entryList.ifNewOpenLog = item.ifNewOpenLog
        this.selectSchoolId = item.fid
        this.entryList.id = item.id
        this.entryList.fid = item.fid
        this.schoolName = item.des ? item.des : ""
        await this.getRoleList()
        if (item.pageNum && item.pageNum != this.pageNum) {
          this.pageNum = item.pageNum
          await this.getSelectList()
        }
      } else {
        this.entryList.label = ""
        this.entryList.value = ""
        this.entryList.ifNewOpenLog = false
        this.selectSchoolId = ""
        this.pageNum = 1
        this.entryList.id = ""
        this.entryList.fid = ""
        this.schoolName = ""
      }
      this.entryList.type = type
      this.entryList.index = index
      if (this.selectSchoolId) {
        // 通过单位id去全部单位中查找roleid
        // let schoolItem = this.allSchoolList.find(it => it.fid === this.selectSchoolId)
        if (item && item.roleIds) {
          let roleIdsList = JSON.parse(item.roleIds)
          this.selectRoleIds = roleIdsList.map(item => item.roleid)
          this.entryList.roleIds = JSON.parse(item.roleIds)
        } else {
          this.selectRoleIds = []
          this.entryList.roleIds = []
        }
      }
      if (this.selectRoleIds.length === this.roleTotalNum && this.selectRoleIds.length !== 0) {
        this.allChecked = true
      } else {
        this.allChecked = false
      }
    },
    handleSchoolDel(item,index) {
      this.schoolList.splice(index,1)
      item.value = ""
      this.entryList.roleIds = []
      this.entryList.type = "del"
      this.updateList(item)
    },
    async handleChangeSchool() {
      let item = this.currentSchoolList.find(it=>it.fid === this.selectSchoolId)
      if(!item) return
      this.entryList.label = item.schoolname
      this.entryList.id = item.id
      this.entryList.ifNewOpenLog = item.target === 1 ? true : false
      this.entryList.fid = item.fid
      this.selectRoleIds = []
      // if (item.roleIds) {
      //   this.selectRoleIds = JSON.parse(item.roleIds).map(item => item.roleid)
      // }
      await this.getRoleList()
      // if (this.selectRoleIds.length === this.roleTotalNum) {
      //   this.allChecked = true
      // } else {
      //   this.allChecked = false
      // }
      this.allChecked = false
    },
    async handleRoleSchool() {
      let list = JSON.parse(JSON.stringify(this.currentRoleIdsList))
      if (list.length !== this.roleTotalNum ) {
        if (this.allRoleIdsList.length !== this.roleTotalNum) {
          await this.getRoleList("all")
        }
        list = this.allRoleIdsList
      }
      let itemList = list.filter(it=>this.selectRoleIds.indexOf(it.roleid) > -1)
      if (itemList.length === this.roleTotalNum) {
        this.allChecked = true
      } else {
        this.allChecked = false
      }
      this.entryList.roleIds = itemList
    },
    handleCurrentChange(curPage) {
      // 选中页码发生改变
      this.pageNum = curPage
      this.getSelectList()
    },
    handleRolesChange(curPage) {
      // 选中页码发生改变
      this.rolePageNum = curPage
      this.getRoleList()
    },
    async selectAllRoles(value) {
      if (value) {
        let list = JSON.parse(JSON.stringify(this.currentRoleIdsList))
        if (list.length !== this.roleTotalNum) {
          // 全选需要获取所有的角色 有分页的情况
          // this.pageSize = this.roleTotalNum
          if (this.allRoleIdsList.length !== this.roleTotalNum) {
            await this.getRoleList("all")
          }
          list = this.allRoleIdsList
        }
        this.selectRoleIds = list.map(item => item.roleid).slice(0, 50)
        this.entryList.roleIds = list
      } else {
        this.selectRoleIds = []
        this.entryList.roleIds = []
        this.pageSize = 10
      }
    }
  }
}
</script>

<style scoped lang="scss">
.mr24 {
  margin-right: 24px !important;
}
.mr4 {
  margin-right: 4px;
}
.verticallyBetween {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.add-menu {
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 16px;
  border-radius: 4px;
  color: var(--themeColor);
  cursor: pointer;
}
.add-menu:hover {
  background: rgba(0, 0, 0, 0.05);
}
.menu-box {
  background: var(--cardBgColor);
  border: 1px solid var(--borderColorFour);
  border-radius: 4px;
  margin-top: 8px;
  padding: 8px;
  .menu-item {
    position: relative;
    height: 32px;
    border-radius: 4px;
    margin-top: 8px;
    &:first-child {
      margin-top: 0;
    }
    .icondrag {
      color: var(--fourthTextColor);
      margin-right: 6px;
      font-size: 16px;
      &:not(.disabled):hover {
        color: var(--themeColor);
        cursor: grab;
      }
      &.dragging {
        cursor: grabbing;
      }
      &.disabled {
        cursor: not-allowed;
      }
    }
    .img {
      width: 20px;
      height: 20px;
      border: 1px solid #dee0e3;
      border-radius: 4px;
      overflow: hidden;
      margin-right: 4px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        vertical-align: top;
      }
    }
    .text {
      width: calc(100% - 80px);
      &.widthlarge {
        width: calc(100% - 56px);
      }
    }
    .btn-box {
      span {
        display: inline-block;
        vertical-align: top;
        width: 24px;
        height: 24px;
        border-radius: 4px;
        text-align: center;
        line-height: 24px;
        color: var(--subTextColor);
        cursor: pointer;
        margin-left: 4px;
        &:hover {
          background: rgba(31, 35, 41, 0.08);
        }
      }
    }
  }
}
::v-deep .chosen {
  background: #FFFFFF !important;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
}
::v-deep .chosen::after {
  content: "";
  height: 0px;
}
::v-deep .ghost {
  border: none !important;
  box-shadow: none !important;
}
::v-deep .ghost::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 100%;
  height: 2px;
  background: var(--themeColor);
}
.menu-set-dialog-wrap {
  position: fixed;
  top: 0;
  right: 0;
  width: 260px;
  bottom: 0;
  background: rgba(0, 0, 0, 0);
  z-index: 9999;
}
.menu-set-dialog {
  position: absolute;
  top: 50%;
  left: 8px;
  right: 8px;
  transform: translateY(-50%);
  background: var(--leftMenuBgColor);
  border: 1px solid var(--borderColorFour);
  box-sizing: border-box;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  .dialog-title {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #F0F0F0;
    padding-left: 12px;
    padding-right: 8px;
    .close {
      width: 24px;
      height: 24px;
      line-height: 24px;
      font-size: 16px;
      border-radius: 4px;
      text-align: center;
      cursor: pointer;
      &:hover {
        color: var(--subTextColor);
        background: var(--inputNuberHoverThemeBgColor);
      }
    }
  }
  .dialog-content {
    padding: 12px 12px 0;
  }
  .dialog-footer {
    padding: 12px;
    text-align: right;
  }
}
::v-deep .text-inp {
  .el-textarea__inner {
    color: rgba(0, 0, 0, 0.8);
    background-color: var(--inputBackGround);
    border: none;
    padding: 6px 12px;
    &:focus {
      box-shadow: inset 0px 0px 0px 2px var(--themeColor);
    }
    &:hover {
      background: var(--inputNuberHoverThemeBgColor);
    }
    &::placeholder {
      font-size: 13px;
      line-height: 20px;
      color: var(--fourthTextColor);
    }
  }
}
.null-box {
  line-height: 32px;
  text-align: center;
  font-size: 12px;
  color: var(--thirdTextColor);
}
.add-select {
  margin-top: 8px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 4px;
  width: 100%;
  height: 32px;
  line-height: 30px;
  text-align: center;
  cursor: pointer;
  .icon-portal-plus {
    display: inline-block;
    vertical-align: top;
    margin-top: 7px;
    margin-right: 2px;
    line-height: 16px;
    text-align: center;
    font-size: 16px;
    color: var(--textColor);
  }
}
.bigScreen .menu-set-dialog .dialog-title {
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}
.bigScreen .add-select {
  border: 1px solid rgba(255, 255, 255, 0.14);
}
.school-select {
  width: 100%;
}
.el-pagination {
  text-align: center;
  margin-top: 10px;
}
.el-pagination ::v-deep button {
  min-width: 22px;
  height: 22px;
  line-height: 22px;
  padding: 0;
}
::v-deep .el-pager li {
  min-width: 22px;
  height: 22px;
  line-height: 22px;
  padding: 0;
  font-weight: 400;
  font-size: 14px;
}
.checked-all {
  width: 100%;
  height: 34px;
  line-height: 34px;
  padding: 0 40px 0 20px;
}
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  display: none;
}
.select-box {
  max-height: 300px;
  overflow-y: auto;
}
</style>